import React from "react";
import PickWidget from "./pick-widget";
import { getFontSizeCss } from "@helpers/css-convertions";
import WrapAlign from "./wrap-align";
import WrapWithStyle from "./wrap-with-style";
import WrapDisplayScope from "./wrap-display-scope";

export const WidgetWrap = (props) => {
    if (!props.children) return null;
    const {
        mrgtop,
        mrgbottom,
        maxWidth,
        minWidth,
        wrapInContentArea,
        smallScreenOnly,
        fontSize,
        data,
        ...rest
    } = props;

    const style = {
        marginTop: `${mrgtop ?? 0}px`,
        marginBottom: `${mrgbottom ?? 0}px`,
        maxWidth: maxWidth ? `${maxWidth}px` : null,
        minWidth: minWidth ? `${minWidth}px` : null,
    };

    const cssVisiblity = smallScreenOnly ? "flex md:hidden" : "flex";

    const css = `${cssVisiblity} ${getFontSizeCss(fontSize) ?? ""}`;

    const Cmp = () => (
        <WrapWithStyle data={data}>
            <div className={css}>
                <div style={style} className="w-full">
                    <WrapAlign data={data}>{props.children}</WrapAlign>
                </div>
            </div>
        </WrapWithStyle>
    );

    return (
        <WrapDisplayScope data={data} {...rest}>
            <Cmp data={data} />
        </WrapDisplayScope>
    );
};

const SingleWidget = ({ widget }) => {
    return (
        <WidgetWrap
            key={widget.name}
            data={widget.data}
            data-wg-name={widget.name}
            data-wg-type={widget.type}
            mrgtop={widget.data.marginTop}
            mrgbottom={widget.data.marginBottom}
            maxWidth={widget.data.maxWidth}
            minWidth={widget.data.minWidth}
            wrapInContentArea={widget.data.wrapInContentArea}
            smallScreenOnly={widget.data.smallScreenOnly ?? false}
            fontSize={widget.data.fontSize}
        >
            <PickWidget widget={widget} />
        </WidgetWrap>
    );
};

export default SingleWidget;
